import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  Button,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
} from 'reactstrap';
import ArrowUpIcon from 'mdi-react/ArrowUpIcon';
import ArrowDownIcon from 'mdi-react/ArrowDownIcon';
import CheckIcon from '../../../shared/components/custom/CheckIcon';
import useModal from '../../../shared/hooks/useModal';
import Api from '../../../util/api';
import DeleteModal from '../../../shared/components/custom/DeleteModal';
import Pagination from '../../../shared/components/pagination/Pagination';
import { partial } from '../../../util/translation/translation';
import { formatDate } from '../../../util/date-and-time';
import { formatCurrencyNumber } from '../../../util/functions';
import useConfig from '../../../util/useConfig';
import moment from 'moment';

const LotteryList = ({ setLoading }) => {
  const config = useConfig();
  const [lotteries, setLotteries] = useState([]);
  const [handleModal, visible, deleteID] = useModal();
  const [pagination, setPagination] = useState({
    total: 0,
    currentPage: 1,
    perPage: 10,
  });
  const [order, setOrder] = useState({
    orderBy: 'createdAt',
    desc: true,
  });
  const p = partial('lotteries');
  const s = partial('shared');

  const fetchLotteries = async (
    currentPage = 1,
    pageSize = 10,
    orderObject = {
      orderBy: 'createdAt',
      desc: true,
    }
  ) => {
    setLoading(true);
    try {
      const resLotteries = await Api.lottery.getLotteries(
        { page: currentPage, take: pageSize },
        {
          orderBy: orderObject.orderBy,
          direction: orderObject.desc ? 'DESC' : 'ASC',
        }
      );
      setLotteries(resLotteries.data);
      setPagination((old) => ({ ...old, total: resLotteries.total }));
      setLoading(false);
    } catch (err) {
      toast.error(p('lotteriesRetrievingERROR'));
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLotteries();
  }, []);
  const deleteLottery = async () => {
    setLoading(true);
    try {
      await Api.lottery.deleteLottery(deleteID);
      toast.success(p('lotteryDeleted'));
    } catch (err) {
      toast.error(p('lotteryDeletedERROR'));
    } finally {
      handleModal();
      fetchLotteries(pagination.currentPage, pagination.perPage, order);
    }
  };

  const onChangePage = (pager) => {
    if (
      pager.pageSize !== pagination.perPage ||
      pager.currentPage !== pagination.currentPage
    ) {
      setPagination((old) => ({
        ...old,
        currentPage: pager.currentPage,
        perPage: pager.pageSize,
      }));
      fetchLotteries(pager.currentPage, pager.pageSize, order);
    }
  };

  const renderSort = (cellOrder) => {
    if (order.orderBy !== cellOrder) {
      return undefined;
    }
    return order.desc ? <ArrowDownIcon size={16} /> : <ArrowUpIcon size={16} />;
  };
  const handleSort = (incommingOrder) => {
    const newOrder = {
      orderBy: incommingOrder,
      desc: incommingOrder === order.orderBy ? !order.desc : true,
    };
    setOrder(newOrder);
    setPagination({
      total: 0,
      currentPage: 1,
      perPage: 10,
    });
    fetchLotteries(1, 10, newOrder);
  };
  const isActive = (lottery) => {
    if (!lottery.isActive) {
      return false;
    }
    if (!lottery.endDate) {
      return moment().isAfter(moment(lottery.startDate));
    }
    return moment().isBetween(
      moment(lottery.startDate),
      moment(lottery.endDate)
    );
  };
  const renderLotteries = () => {
    return lotteries.map((lottery, i) => (
      <tr
        style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
        key={`lottery-${lottery.id}`}
      >
        <td>
          <div className="flex-Vcenter">
            <Link to={`/lottery/edit/${lottery.id}`}>{lottery.name}</Link>
          </div>
        </td>

        <td>{formatDate(lottery.startDate)}</td>
        <td>{formatDate(lottery.endDate)}</td>
        <td>
          {formatCurrencyNumber(lottery.ticketPrice || 0)} {config.currencyCaps}
        </td>
        <td>{lottery.ticketCount}</td>
        <td>
          {formatCurrencyNumber(lottery.turnover || 0)} {config.currencyCaps}
        </td>
        <td>
          <CheckIcon state={isActive(lottery)} />
        </td>
        <td>
          <UncontrolledDropdown className="dashboard__table-more">
            <DropdownToggle>
              <DotsHorizontalIcon />
            </DropdownToggle>
            <DropdownMenu className="dropdown__menu">
              <Link to={`/lottery/edit/${lottery.id}`}>
                <DropdownItem>{s('edit')}</DropdownItem>
              </Link>
              <Link to={`/lottery/clone/${lottery.id}`}>
                <DropdownItem>{s('clone')}</DropdownItem>
              </Link>
              <DropdownItem
                onClick={() => handleModal(lottery.id)}
                className="danger"
              >
                {s('delete')}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </td>
      </tr>
    ));
  };
  return (
    <Container>
      <DeleteModal
        visible={visible}
        type={p('lottery')}
        handleModal={handleModal}
        modalAction={deleteLottery}
      />
      <Row>
        <Col>
          <div className="float-right marginTop-0">
            <Link to="/lottery/create">
              <Button size="sm" color="primary">
                {p('createLottery')}
              </Button>
            </Link>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div
            style={{
              display: 'flex',
              paddingBottom: 5,
              background: '#fff',
              borderRadius: 6,
              boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
            }}
          >
            <Table responsive striped>
              <thead>
                <tr>
                  <th
                    style={{ color: '#4D576A' }}
                    className="sortable"
                    onClick={() => handleSort('name')}
                  >
                    <div className="flex alignItems-center">
                      {s('name')} {renderSort('name')}
                    </div>
                  </th>
                  <th
                    style={{ color: '#4D576A' }}
                    className="sortable"
                    onClick={() => handleSort('startDate')}
                  >
                    <div className="flex alignItems-center">
                      {s('startDate')} {renderSort('startDate')}
                    </div>
                  </th>
                  <th
                    style={{ color: '#4D576A' }}
                    className="sortable"
                    onClick={() => handleSort('endDate')}
                  >
                    <div className="flex alignItems-center">
                      {s('endDate')} {renderSort('endDate')}
                    </div>
                  </th>
                  <th style={{ color: '#4D576A' }}>
                    <div className="flex alignItems-center">
                      {p('pricePerTicket')}
                    </div>
                  </th>
                  <th
                    style={{ color: '#4D576A' }}
                    className="sortable"
                    onClick={() => handleSort('ticketCount')}
                  >
                    <div className="flex alignItems-center">
                      {p('soldTickets')} {renderSort('ticketCount')}
                    </div>
                  </th>
                  <th
                    style={{ color: '#4D576A' }}
                    className="sortable"
                    onClick={() => handleSort('turnover')}
                  >
                    <div className="flex alignItems-center">
                      {p('turnover')} {renderSort('turnover')}
                    </div>
                  </th>
                  <th style={{ color: '#4D576A' }} className="sortable">
                    <div className="flex alignItems-center">{s('active')}</div>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>{renderLotteries()}</tbody>
            </Table>
          </div>
          <Pagination
            items={pagination.total}
            onChangePage={onChangePage}
            initialPage={pagination.currentPage}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default LotteryList;
